import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoItemDescontoMaximoExcedidoTableViewModule } from '../../../item/components/desconto-maximo-excedido-table-view';

import { PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosComponent } from './pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoItemDescontoMaximoExcedidoTableViewModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosComponent
    ]
})
export class PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosModule { }
